<template>
    <header class="header" id="header">
        <div class="container">
            <nav class="header__menu">
                <router-link :to="{name:'home'}" class="menu__logo" :class="{'active': $route.name === 'home'}">
                    <img :src="require(`@/assets/images/${$t('logoUrl')}`)" alt="logo">
                </router-link>
                <ul class="menu__list clearfix">
                    <li class="menu__item">
                    <router-link :to="{name:'home'}" class="menu__item__link" :class="{'active': $route.name === 'home'}">
                        {{ $t('mainPage') }}
                    </router-link>
                    </li>
                    <li class="menu__item">
                    <router-link :to="{name:'policy'}" class="menu__item__link" :class="{'active': $route.name === 'policy'}">
                        {{ $t('aboutProject') }}
                    </router-link>
                    </li>
                    <li class="menu__item">
                        <router-link :to="{name:'connection'}" class="menu__item__link" :class="{'active': $route.name === 'connection'}">
                            {{ $t('connection') }}
                        </router-link>
                    </li>
                    <li class="menu__item">
                            <router-link :to="{name:'faq'}" class="menu__item__link" :class="{'active': $route.name === 'faq'}">
                                {{ $t('help') }}
                            </router-link>
                        </li>
                    <li class="menu__item">
                        <ChangeLangBtn />
                    </li>
                    <li class="menu__item" v-if="$route.fullPath !== '/login'">
                        <router-link :to="{name:'login'}" class="menu__item__link menu__enter default__button">
                            {{ $t('signIn') }}
                        </router-link>
                    </li>
                </ul>
                <div class="header__right__mob">
                    <ChangeLangBtn class="menu__lan__switcher__mob" />
                    <button class="menu__button" @click="AddOpen" :class="{open: isOpen}">
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>
            </nav>
        </div>
        <div class="menu__overlay" :class="{open: isOpen}">
            <div class="container">
                <div class="mob__menu__wrap">
                    <ul class="menu__list__mob">
                        <li class="menu__item">
                            <router-link :to="{name:'home'}" class="menu__item__link" :class="{'active': $route.name === 'home'}">
                                {{ $t('mainPage') }}
                            </router-link>
                        </li>
                        <li class="menu__item">
                            <router-link :to="{name:'policy'}" class="menu__item__link" :class="{'active': $route.name === 'policy'}">
                                {{ $t('aboutProject') }}
                            </router-link>
                        </li>
                        <li class="menu__item">
                            <router-link :to="{name:'connection'}" class="menu__item__link" :class="{'active': $route.name === 'connection'}">
                                {{ $t('connection') }}
                            </router-link>
                        </li>
                        <li class="menu__item">
                            <router-link :to="{name:'faq'}" class="menu__item__link" :class="{'active': $route.name === 'faq'}">
                                {{ $t('help') }}
                            </router-link>
                        </li>
                        <li class="menu__item" v-if="$route.fullPath !== '/login'">
                            <router-link :to="{name:'login'}"  class="menu__item__link" :class="{'active': $route.name === 'login'}">
                                {{ $t('signIn') }}
                            </router-link>
                        </li>
                    </ul>
<!--                    <ul class="menu__list__mob">-->
<!--                        <li class="menu__item" v-if="$route.fullPath !== '/login'">-->
<!--                            <router-link :to="{name:'login'}" class="menu__item__link default__button">-->
<!--                                    {{ $t('signIn') }}-->
<!--                            </router-link>-->
<!--                        </li>-->
<!--                    </ul>-->
                </div>
            </div>
        </div>
    </header>
        <!--        <div class="menu" id="showMenu" ref="showMenu">
            <i class="fa fa-close" @click="RemoveMenu">zzz</i>
        </div>
        <i class="fa fa-bars" @click="ShowMenu"></i>-->
</template>

<script>
import SelectLang from '../../components/select/SelectLang'
import ChangeLangBtn from '@/components/button/ChangeLangBtn.vue'
export default {
  name: 'navbar',
  components: { ChangeLangBtn, SelectLang },
  data () {
    return {
      activeItem: '',
      isOpen: false
    }
  },
  methods: {
    ShowMenu () {
      this.$refs.showMenu.style.visibility = 'visible'
      console.log(this.$refs.showMenu.style.right)
    },
    RemoveMenu () {
      this.$refs.showMenu.style.visibility = 'hidden '
      console.log(this.$refs.showMenu.style.right)
    },
    AddOpen () {
      this.isOpen = !this.isOpen;
    }
  }
}
</script>

<style lang="scss" scoped>

    .navbar-nav {
        box-sizing: border-box;
        display: inline;
        -webkit-box-orient: horizontal;
        -webkit-box-direction: normal;
        -ms-flex-direction: row;
        flex-direction: row;
        padding-left: 0;
        margin-bottom: 0;
        list-style: none;
    }

    ul {
        box-sizing: border-box;
        margin-block-start: 1em;
        margin-block-end: 1em;
        margin-inline-start: 0px;
        margin-inline-end: 0px;
    }

    li {
        display: list-item;
        text-align: -webkit-match-parent;
    }

    .nav-item .active, li a:hover {
        color: #167ce9;
    }

    .ml-auto {
        margin-left: auto !important;
    }

    .nav-item {
        margin: 0;
        list-style: none;
        display: inline-block;
        padding: 42px 0;
    }

    .nav-item a {
        font-size: 16px;
        line-height: 160%;
        text-decoration: none;
        text-align: center;
        color: #4B5D68;
        padding-right: 25px;
        margin: 0;
        box-sizing: border-box;
        padding-left: 25px;
    }

    .nav .fa {
        display: none;
    }

    @media (max-width: 1216px) {
        .nav {
            max-width: 1200px;
            width: 100%;
            padding-left: 50px;
            padding-top: 30px;
            padding-bottom: 50px;
            padding-right: 40px;
        }

        .nav-item a {
            padding-right: 10px;
            padding-left: 10px;
        }

        .menu {
            flex-basis: auto;
        }

    }

    @media (max-width: 992px) {
        .fa-bars {
            position: absolute;
            right: 30px;
            background: #1122c4;
        }

        .nav .fa {
            display: block;
            color: #fff;
            margin: 15px 25px;
            font-size: 22px;
            cursor: pointer;
        }

        .menu {
            height: 100vh;
            width: 200px;
            background: linear-gradient(180deg, #563ae5 0%, #339DFA 100%);
            top: 0;
            right: 0;
            position: absolute;
            visibility: hidden;
            text-align: left;
            z-index: 2;
        }

        .nav-item {
            padding: 15px 15px;
        }

        .navbar-nav li {
            display: block;
            text-align: left;
        }

        .navbar-nav li:hover {
            color: #073c76;
        }

        .nav-item .active, menu ul a {
            color: #073c76;
        }

        .menu ul a {
            line-height: normal;
            color: white;
            font-weight: 800;
            font-size: 20px;

        }

        .menu .sign {
            float: none;
            margin-left: 20px;
            margin-top: 15px;
        }

        .nav .fa {
            display: block;

        }
    }

    @media (max-width: 700px) {
        .fa-bars {
            position: absolute;
            right: 30px;
            background: #1122c4;
        }

        .nav .fa {
            display: block;
            color: #fff;
            margin: 15px 25px;
            font-size: 22px;
            cursor: pointer;
        }

        .menu {
            height: 100vh;
            width: 200px;
            background: linear-gradient(180deg, #563ae5 0%, #339DFA 100%);
            top: 0;
            right: 0;
            position: absolute;
            visibility: hidden;
            text-align: left;
            z-index: 2;
        }

        .nav-item {
            padding: 15px 15px;
        }

        .navbar-nav li {
            display: block;
            text-align: left;
        }

        .menu ul a {
            line-height: normal;
        }

        .menu .sign {
            float: none;
            margin-left: 20px;
            margin-top: 15px;
        }

        .nav .fa {
            display: block;

        }
    }
</style>
